import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";

export default function TableErja({
  rowData,
  gridRef,
  create,
  areaId,
  date,
  date1,
}) {
  const [selection, setSelection] = useState([]);
  const onSelectionChanged = (e) => {
    const selectedNodes = e.api.getSelectedNodes();
    const lastSelectedNode =
      selectedNodes[0]?.selectionController?.lastSelectedNode;
    // if lastSelectedNode is missing while multi-selecting,
    // AgGrid will select from the first row
    const selectedNodeFrom = lastSelectedNode || e.api.getRenderedNodes()[0];
    const isRangeSelect = KEYBOARD_STATE.isShiftPressed;
    const difference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x));
    const newSelection = difference(selectedNodes, selection);

    if (newSelection.length > 0) {
      if (isRangeSelect) {
        const isSelectBackward =
          newSelection[0].rowIndex < selectedNodeFrom.rowIndex;

        if (isSelectBackward) {
          newSelection.reverse();
        }
      }

      newSelection.forEach((n) => updateSelection(n));
    } else {
      updateSelection(); // deselect
    }
  };
  const KEYBOARD_STATE = {
    isShiftPressed: false,
  };
  document.addEventListener("keydown", (e) => {
    KEYBOARD_STATE.isShiftPressed = e.key === "Shift";
  });
  document.addEventListener("keyup", (e) => {
    KEYBOARD_STATE.isShiftPressed = false;
  });
  const updateSelection = (rowNode) => {
    setSelection((selections) => {
      if (rowNode) {
        const isSelected = rowNode.isSelected();

        if (isSelected) {
          return [...selections, rowNode];
        } else {
          return selections.filter((s) => s.id !== rowNode.id);
        }
      } else {
        return selections.filter((n) => n.isSelected());
      }
    });
  };
  // console.log(rowData);
  const [colDefs] = useState([
    {
      headerName: "ردیف",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },

    {
      field: "name",
      headerName: "نام و نام خانوادگی",
      width: 200,
    },
    {
      field: "identifier",
      headerName: "کد ملی",
      width: 200,
    },

    {
      field: "insurance",
      headerName: "نوع بیمه",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x?.data?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.insurance === "MILITARY"
                ? "نیروهای مسلح"
                : x?.data?.insurance === "TAMIN"
                ? "تامین اجتماعی"
                : x?.data?.insurance === "SALAMAT"
                ? "سلامت"
                : "ندارد "}{" "}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "phone",
      headerName: "شماره تلفن",
      width: 200,
    },
    {
      field: "fatherName",
      headerName: "نام پدر",
      width: 200,
    },
    {
      field: "birthDate",
      headerName: "تاریخ تولد",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.birthDate?.split("-", 2)[0]}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "patientNo",
      headerName: "شماره پرونده ",
      width: 200,
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: false,
  }));

  return (
    <>
      <div
        className="ag-theme-quartz"
        style={{ height: create ? 120 : "55vh", marginTop: 10 }}
      >
        <AgGridReact
          // pagination={true}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
          onSelectionChanged={onSelectionChanged}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
          onCellClicked={(e) => {
            window.open(
              `/parvandeh?${areaId}&${e.data?.identifier}&${e.data?.identifierType}&${e.data?.id}&erja`,
              "_blank"
            );
          }}
        />
      </div>
    </>
  );
}
